/* tslint:disable */
/* eslint-disable */
/**
 * REST API for AWV-UI
 * AWV-UI向けのREST APIリファレンス  ## Version履歴 - 1.0:2023/4/28 初版作成 - 1.1:2023/6/30   - すべてのAPIリファレンスを一つにまとめた   - Suspend Task→Cancel Taskに名前を変更   - 認証開始　削除   - トークン更新　認証処理の見直しにより全体修正   - タスク取得　レスポンスのユーザ名をユーザIDに変更、タスク状態修正   - Awrs→Awvsに修正   - 完成機情報取得　レスポンスに「カメラ仕様」「名称ID」追加、パラメータに車台形式・番号追加   - Go Home Task　レスポンスのtaskIDをjobsetId修正   - 以下API新規追加     - WebRTC配信設定     - WebRTC接続情報取得     - WebRTCユーザー設定     - パスワードリセット     - アンロックアカウント実行     - アンロックアカウントメール送信 - 1.2:2023/7/28   - 地図情報取得　パラメータのinをpathに修正   - タスク作成状況確認　パラメータの指定方法修正   - UnlockAccountResponseStatus204のref先変更   - 全APIにoperationId付与   - Skip Task　エラーレスポンス追加   - Cancel Task　エラーレスポンス追加   - プロジェクト一覧取得　レスポンスにジョブサイト名追加　400エラー削除   - トークン更新　レスポンスの204を削除し200を追加。レスポンスにemail、roleNameを追加   - タスク取得　レスポンス、リクエストパラメータ修正   - 完成機情報取得　正常レスポンス(200)の応答をobject形式に修正。処理概要に完成機1台分の情報取得の旨追記   - タスク作成状況確認　正常レスポンス(200)の応答をobject形式に修正   - タスク更新　リクエストをリクエストボディに変更し内容を修正。レスポンス修正   - タスク取得　正常レスポンス(200)の応答をobject形式に修正   - タスク名一覧取得　正常レスポンス(200)の応答をobject形式に修正   - WebRTC配信設定情報　正常レスポンス(200)の応答をobject形式に修正   - タスク登録　リクエストパラメータの内容修正   - タスク削除　リクエストパラメータの内容修正   - タスク作成状況確認　タスク作成時の409エラーを追加   - API設計方針追記 及び伴うエラーコードレスポンスをstringに修正   - マップ503エラーレスポンスの説明を500から503に修正   - 地図更新確認　リクエストパラメータの内容修正。200レスポンスの内容修正。204レスポンス削除。   - タスク登録　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク更新　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク名一覧取得　経由ノードのリストと、from地点ノードでの停止時間をレスポンスに追加。   - タスク取得　パラメータの必須かどうかを修正。経路情報取得の要否削除。レスポンスの必須かどうかを修正。   - タスク名一覧取得　レスポンス名をキャメルケースに修正し、配列でなくした。   - タスク承認　リクエストパラメータをキャメルケースに修正   - タスク取得　リクエストパラメータに「再計算タスク取得フラグ」を追加。レスポンスの必須かどうかを修正。   - WebRTC接続情報取得　レスポンスパラメータから「日時」を削除。「webRTC配信の停止」のパラメータ名を修正   - タスク作成状況確認　 レスポンスパラメータ名を修正 jobsetStatus → jobSetStatus   - Go Home Task、Cancel Task、Skip Taskを一つのタグにまとめた。   - パラメータ等にrequireで存在しないものが指定されているのを修正   - ResistTaskDataをRegisterTaskDataに修正   - 交通状況編集　レスポンス内容をバージョンIDのみに修正。204削除。   - Go Home Task実行 リクエストパラメータの日時情報候補リスト削除し、fromノードIDと開始希望日時追加。 - 1.3:2023/9/29   - Go Home Task実行　パラメータのrequireを修正   - WebRTC配信設定　「WebRTC解像度」と「WebRTCフレームレート」をrequireから外した   - 地図情報取得　レスポンスの地図情報の内容修正。204レスポンス削除。レスポンスに作成日時、更新日時、作成ユーザを追加。   - 交通状況編集　パラメータの地図情報をエッジ更新情報に修正   - 完成機情報取得　パラメータのgeoSiteId→jobSiteIdに修正。204レスポンス削除。   - usersに属するAPIから、AUTHORIZATIONS:PermissionTokenを削除   - タスク取得　Dateをdateにし、型も修正。レスポンスの「タスク実行予定時刻」の名称を「タスク実行予定時間（分）」に修正。レスポンスの経路情報にノードの到着時間と出発時間を追加。JobInfosの内部的な仕様修正。画面表示用タスクIDの例のスペル修正。レスポンスのバージョンIDに説明追加。   - 通知一覧取得　APIの説明文修正。パラメータの取得上限数の説明文修正、requireに指定、範囲を1～500に指定。レスポンスの通知情報内容修正。レスポンスに「車台形式・番号」追加404エラー追加。レスポンスに画面表示用タスクID追加。   - 通知既読　削除。   - 通知更新確認　APIの説明文修正。レスポンスの最新通知情報において、該当するイベントが0件だった場合未設定(null)とする旨を説明に追記及びレスポンスに「車台形式・番号」追加。レスポンスに画面表示用タスクID追加。   - プロジェクト一覧取得　ソートして返却する旨を記載   - トークン更新　レスポンスに名前、名字を追加   - jobsetStatus → jobSetStatusに修正   - メモ設定のpatternに空白文字追加 及び 1個以上ではなく0個以上に一致するよう修正   - タスク登録　パラメータのextensionTimeLoadをrequiredから外し、説明文を修正   - タスク更新　パラメータのextensionTimeLoadをrequiredから外した。   - タスク承認　リクエストボディをリスト化。   - タスク名一覧取得　JobInfosの内部的な仕様修正。extensionTimeLoadをrequiredから外した。   - WebRTCユーザー設定　200レスポンスを204に修正。   - WebRTC接続情報取得 200レスポンスの説明文修正。 - 1.4:2023/10/24   - 交通状況編集のレスポンスに最適化対象ジョブセットIDリストを追加   - タスク取得のパラメータに最適化対象ジョブセットIDリストを追加 - 1.4.1:2023/10/31   - タスク取得(一括承認用)APIを追加し、タスク取得APIから該当パラメータを削除 - 1.4.2:2023/11/08   - タスク取得(一括承認用)APIのリクエストパラメータを最適化対象ジョブセットIDからオブジェクトに修正   - 交通状況編集のレスポンスの最適化対象ジョブセットIDからオブジェクトに修正   - タスク取得APIのリクエストパラメータの地図バージョンを削除 - 1.4.3:2024/01/10   - タスク取得APIのレスポンスに移動タスク生成フラグを追加   - タスク登録APIのリクエストパラメータにタスク補完設定(移動タスク生成フラグ)を追加   - タスク取得APIのリクエストパラメータに承認待ちタスクのみ取得するフラグを追加   - 完成機情報取得のレスポンスの内容修正(conditionに「OTA中」を追加)   - 完成機情報取得のレスポンスに自律走行可否を追加 - 1.4.4:2024/01/23   - タスク取得のリクエストパラメータにパスデータを取得するか否かのフラグを追加   - タスク取得のレスポンスに経由パスのリストを追加   - プロジェクト一覧取得APIのレスポンスに地理サイト名と{ジョブサイトID, ジョブサイト名}を追加   - 地図情報取得APIのリクエストパラメータをジョブサイトIDから地図IDに変更   - 地図一覧取得APIを追加 - 1.4.5:2024/02/15   - 地図情報取得のレスポンスタイプMapEdgeTypeにoneWayを追加 - 1.5:2024/03/06   - 緊急停止実行APIを追加 - 1.6:2024/10/04   - 荷物情報取得APIを追加   - 充電器情報取得APIを追加 - 1.7:2024/10/17   - 充電運行計画のタスク登録APIを追加   - 充電運行計画のタスク更新APIを追加   - 充電運行計画のタスク取得APIを追加   - 充電運行計画のタスク名一覧取得APIを追加 - 1.8:2024/10/22   - ユーザー一覧取得APIを追加   - プロジェクト一覧取得のレスポンスに組織ID追加   - 充電運行計画のタスク名一覧取得のリクエストパラメータにinputDateを追加 - 1.8.1:2024/10/25   - 充電運行計画のタスク登録のリクエストパラメータにendDatetimeを追加   - 充電運行計画のタスク更新のリクエストパラメータにendDatetimeを追加 - 1.8.2:2024/11/07   - 充電運行計画のタスク名一覧取得のリクエストパラメータにjobSetIdを追加 - 1.8.3:2024/11/11   - 充電運行計画のタスク名一覧取得のレスポンスのjobInfosにjobIdを追加 - 1.8.4:2024/11/18   - 充電運行計画のタスク取得のレスポンスにバージョンIDを追加   - 充電運行計画のタスク名一覧取得のレスポンスにバージョンIDを追加 - 1.8.5:2024/11/21   - 充電運行計画のタスク登録／更新リクエストのジョブ終了希望日時のパラメータ名を修正 - 1.8.6:2024/11/22   - 充電運行計画のタスク取得のレスポンスに荷物数量を追加 - 1.8.7:2024/11/28   - 充電運行計画のタスク取得のレスポンスのjobPlanningEndDatetimeをrequiredから外した。  ## API設計方針 - 要求仕様: [API設計ガイドライン](https://hndx-gh-ex01.rd.honda.co.jp/OPPF-2X-DEV-COMMON-COMPONENTS/requirements/blob/master/api/api_design_guideline.md) - Description は APIの概要の記載にとどめ、初期値といった Swagger で用意されている記載方法がある場合はそれに則る書き方にする。 - OP-PFからのエラーレスポンスコードがある場合はintgerからstringに変換して返す。  上記を設計原則とするが、例外となるものは明記する。  ## Deprecated APIについて OP-PF AWV-UIにおいて、初期に利用されていたAPIをDeprecatedとして明示している。 - 新規での利用はしないこと。 - 実装のメンテナンスは行われず、テスト対象にもしない。 - 将来的に実装は取り除かれ、API仕様からも削除される 
 *
 * The version of the OpenAPI document: 1.8.6
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Map400ErrorResponse,
  Map403ErrorResponse,
  Map500ErrorResponse,
  Map503ErrorResponse,
  MapData,
  MapSummaries,
  MapUpdateCheckData,
  MapUpdateData,
  UpdateMap200Response,
} from '../models';
import {
    Map400ErrorResponseFromJSON,
    Map400ErrorResponseToJSON,
    Map403ErrorResponseFromJSON,
    Map403ErrorResponseToJSON,
    Map500ErrorResponseFromJSON,
    Map500ErrorResponseToJSON,
    Map503ErrorResponseFromJSON,
    Map503ErrorResponseToJSON,
    MapDataFromJSON,
    MapDataToJSON,
    MapSummariesFromJSON,
    MapSummariesToJSON,
    MapUpdateCheckDataFromJSON,
    MapUpdateCheckDataToJSON,
    MapUpdateDataFromJSON,
    MapUpdateDataToJSON,
    UpdateMap200ResponseFromJSON,
    UpdateMap200ResponseToJSON,
} from '../models';

export interface GetJobsiteMapsRequest {
    jobSiteId: string;
}

export interface GetMapInfoRequest {
    jobSiteId: string;
    mapId: string;
}

export interface GetMapUpdateRequest {
    mapId: string;
    mapVer: number;
}

export interface UpdateMapRequest {
    mapId: string;
    mapVer: number;
    mapUpdateData: MapUpdateData;
}

/**
 * 
 */
export class MapApi extends runtime.BaseAPI {

    /**
     * ジョブサイトIDをもとに閲覧可能地図一覧を取得する。
     * 地図一覧取得
     */
    async getJobsiteMapsRaw(requestParameters: GetJobsiteMapsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MapSummaries>> {
        if (requestParameters.jobSiteId === null || requestParameters.jobSiteId === undefined) {
            throw new runtime.RequiredError('jobSiteId','Required parameter requestParameters.jobSiteId was null or undefined when calling getJobsiteMaps.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/maps/{jobSiteId}`.replace(`{${"jobSiteId"}}`, encodeURIComponent(String(requestParameters.jobSiteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MapSummariesFromJSON(jsonValue));
    }

    /**
     * ジョブサイトIDをもとに閲覧可能地図一覧を取得する。
     * 地図一覧取得
     */
    async getJobsiteMaps(requestParameters: GetJobsiteMapsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MapSummaries> {
        const response = await this.getJobsiteMapsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 地図IDをもとに最新の地図の地図情報を取得し、返却する。
     * 地図情報取得
     */
    async getMapInfoRaw(requestParameters: GetMapInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MapData>> {
        if (requestParameters.jobSiteId === null || requestParameters.jobSiteId === undefined) {
            throw new runtime.RequiredError('jobSiteId','Required parameter requestParameters.jobSiteId was null or undefined when calling getMapInfo.');
        }

        if (requestParameters.mapId === null || requestParameters.mapId === undefined) {
            throw new runtime.RequiredError('mapId','Required parameter requestParameters.mapId was null or undefined when calling getMapInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/maps/{jobSiteId}/{mapId}`.replace(`{${"jobSiteId"}}`, encodeURIComponent(String(requestParameters.jobSiteId))).replace(`{${"mapId"}}`, encodeURIComponent(String(requestParameters.mapId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MapDataFromJSON(jsonValue));
    }

    /**
     * 地図IDをもとに最新の地図の地図情報を取得し、返却する。
     * 地図情報取得
     */
    async getMapInfo(requestParameters: GetMapInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MapData> {
        const response = await this.getMapInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 地図データのヘッダ情報を取得し、現時点の地図と比較した結果を返す。
     * 地図更新確認
     */
    async getMapUpdateRaw(requestParameters: GetMapUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MapUpdateCheckData>> {
        if (requestParameters.mapId === null || requestParameters.mapId === undefined) {
            throw new runtime.RequiredError('mapId','Required parameter requestParameters.mapId was null or undefined when calling getMapUpdate.');
        }

        if (requestParameters.mapVer === null || requestParameters.mapVer === undefined) {
            throw new runtime.RequiredError('mapVer','Required parameter requestParameters.mapVer was null or undefined when calling getMapUpdate.');
        }

        const queryParameters: any = {};

        if (requestParameters.mapVer !== undefined) {
            queryParameters['mapVer'] = requestParameters.mapVer;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/maps/{mapId}/header`.replace(`{${"mapId"}}`, encodeURIComponent(String(requestParameters.mapId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MapUpdateCheckDataFromJSON(jsonValue));
    }

    /**
     * 地図データのヘッダ情報を取得し、現時点の地図と比較した結果を返す。
     * 地図更新確認
     */
    async getMapUpdate(requestParameters: GetMapUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MapUpdateCheckData> {
        const response = await this.getMapUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * リクエストされた地図情報を更新する。 更新後、新しく採番した地図バージョンと最適化対象ジョブリストを返却する。
     * 交通状況編集
     */
    async updateMapRaw(requestParameters: UpdateMapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateMap200Response>> {
        if (requestParameters.mapId === null || requestParameters.mapId === undefined) {
            throw new runtime.RequiredError('mapId','Required parameter requestParameters.mapId was null or undefined when calling updateMap.');
        }

        if (requestParameters.mapVer === null || requestParameters.mapVer === undefined) {
            throw new runtime.RequiredError('mapVer','Required parameter requestParameters.mapVer was null or undefined when calling updateMap.');
        }

        if (requestParameters.mapUpdateData === null || requestParameters.mapUpdateData === undefined) {
            throw new runtime.RequiredError('mapUpdateData','Required parameter requestParameters.mapUpdateData was null or undefined when calling updateMap.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/maps/{mapId}/{mapVer}`.replace(`{${"mapId"}}`, encodeURIComponent(String(requestParameters.mapId))).replace(`{${"mapVer"}}`, encodeURIComponent(String(requestParameters.mapVer))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MapUpdateDataToJSON(requestParameters.mapUpdateData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateMap200ResponseFromJSON(jsonValue));
    }

    /**
     * リクエストされた地図情報を更新する。 更新後、新しく採番した地図バージョンと最適化対象ジョブリストを返却する。
     * 交通状況編集
     */
    async updateMap(requestParameters: UpdateMapRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateMap200Response> {
        const response = await this.updateMapRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
